import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';


import "./nav.css"








const Navbar = () => {

    const { user, logout } = useContext(AuthContext);
    const [activeMenu, setActiveMenu] = useState(null);
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);

    const menuItems = [
        { label: 'Home', route: '/' },
        { label: 'Our Story', route: '/ourstory' },
        { label: 'Our Farm', route: '/ourfarm' },
        { label: 'Products', route: '/Product' },
        { label: 'Contact Us', route: '/contactus' }
    ];

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCartItems(storedCart);
    }, []);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);

        const handleClickOutside = (event) => {
            if (!event.target.closest('.menu') && !event.target.closest('.user-icon')) {
                setActiveMenu(null);
            }
        };

        window.addEventListener('scroll', handleScroll);
        document.addEventListener('click', handleClickOutside);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const toggleMenu = (menu) => {
        setActiveMenu((prevMenu) => (prevMenu === menu ? null : menu));
    };

    const menuStyle = {
        position: 'absolute',
        right: '0',
        marginTop: '10px',
        width: '180px',
        background: 'white',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '8px',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
    };

    const hiddenStyle = {
        opacity: 0,
        transform: 'translateY(-10px)',
        pointerEvents: 'none',
    };

    const listItemStyle = {
        padding: '12px',
        cursor: 'pointer',
        borderRadius: '4px',
        fontSize: '18px',
        transition: 'background 0.3s ease',
        display: 'flex',
        alignItems: 'center',


    };

    const listItemHoverStyle = {
        background: '#d2ab67',
        fontweight: 'bold',
        color: 'white',
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth < 640;

    return (
        <nav className={scrolled ? 'scrolled' : ''}>
            <div className="overlay">
                <img onClick={() => navigate('/')} src="../images/logo-icon.webp" alt="Whyte Farms" height={'85px'} style={{ marginTop: '10px', cursor: 'pointer' }} />
            </div>

            <div

                style={{
                   
                    padding: isMobile ? "8px 10px" : "10px 16px",
                    fontSize: isMobile ? " 9px " : " 12px ",
                    boxSizing: "border-box",
                    display: "flex",
                    textTransform: "none",
                    flexDirection: isMobile ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    gap: isMobile ? "8px" : "16px",
                    // fontSize: isMobile ? "12px" : "14px",
                    // color: "white",
                    // borderBottom: "1px solid #ccc",
                    background: "transparent",
                }}
            >
                <a
                    href="https://panindia.whytefarms.com/"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                        textDecoration: "none",
                        color: "white",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                    }}
                >
                    <span class="custom-font-size">
                        Now delivering ghee, PAN India. Click here to order
                    </span>


                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 14 10"
                        style={{
                            width: "16px",
                            height: "16px",
                            fill: "white",
                        }}
                    >
                        <path
                            fillRule="evenodd"
                            d="M8.537 8.88L7.817 9.62 13.455 4 7.817.38l.72.74 4.405 4.38zM0 4h12.76v1H0z"
                        />
                    </svg>
                </a>
            </div>





















            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', position: 'relative' }}>
                <div style={{ position: 'relative' }}>
                    <img className="user-icon" style={{ width: '40px', height: '40px', cursor: 'pointer', borderRadius: '50%' }} src="../images/user2.png" onClick={() => toggleMenu('profile')} alt="User Profile" />
                    <div style={activeMenu === 'profile' ? menuStyle : { ...menuStyle, ...hiddenStyle }}>
                        <ul style={{ listStyle: 'none', padding: '0', margin: '0', fontSize: '14px', color: '#333' }}>
                            <li style={{ ...listItemStyle }} onMouseEnter={(e) => e.target.style.background = listItemHoverStyle.background} onMouseLeave={(e) => e.target.style.background = ''} onClick={user ? () => navigate('/profile') : () => navigate('/login')}>
                                <i className="ph-bold ph-user"></i>&nbsp;{user ? 'Profile' : 'Login'}
                            </li>
                            {user && (
                                <li style={{ ...listItemStyle }} onMouseEnter={(e) => e.target.style.background = listItemHoverStyle.background} onMouseLeave={(e) => e.target.style.background = ''} onClick={() => { logout(); setCartItems([]); localStorage.removeItem('cart'); navigate('/'); }}>
                                    <i className="ph-bold ph-gear-six"></i>&nbsp;Logout
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <div style={{ position: 'relative' }}>
                    <img style={{ width: '40px', height: '40px', cursor: 'pointer' }} onClick={() => navigate('/cart')} src="../images/cart2.png" alt="Cart" />
                    {cartItems.length > 0 && (
                        <span style={{ position: 'absolute', top: '-5px', right: '-5px', background: 'red', color: 'white', fontSize: '12px', borderRadius: '50%', padding: '2px 6px' }}>
                            {cartItems.length}
                        </span>
                    )}
                </div>

                <div style={{ position: 'relative' }}>
                    <img className="user-icon" style={{ width: '30px', height: '30px', cursor: 'pointer' }} onClick={() => toggleMenu('static')} src="../images/tog.png" alt="Toggle Menu" />
                    <div style={activeMenu === 'static' ? menuStyle : { ...menuStyle, ...hiddenStyle }}>
                        <ul style={{ listStyle: 'none', padding: '0', margin: '0', fontSize: '14px', color: '#333' }}>
                            {menuItems.map((item, index) => (
                                <li key={index} style={{ ...listItemStyle }} onMouseEnter={(e) => e.target.style.background = listItemHoverStyle.background} onMouseLeave={(e) => e.target.style.background = ''} onClick={() => navigate(item.route)}>
                                    {item.label.toUpperCase()}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
